var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXcode1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.62 14.95h54v41h-54z",
    fill: "#63b2ff",
    transform: "matrix(.98822838 -.15298584 .15298584 .98822838 -5.059959 5.099965)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10 58-6-38m11 26-2-13m34 8-2-13m13 21-50 8m50-9.96-50 8m43-42.04 6 38m-54-29 51-8m-44 23 40-7m-38 14 39-7",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m63.27 9.18c-2-.85-3.92-2.24-6.42-1.37a2.78 2.78 0 0 1 -2.53-.89c-1.53-2.74-4.32-3.44-6.84-3.92-11.26-2.12-15.93 3.65-17.14 4.74.12.26.24.52.37.78a.61.61 0 0 0 0 .12c.68-.1 5.63-2.19 9.22.06 1.62 1 2.75 2.35 2.45 4.25a3.84 3.84 0 0 1 -.09.44c-.06.2 0 .24-.06.45l.18.06 4.73 1.54c.07-.14.15-.35.23-.48 1.8-2.92 5.4-1.68 7.37.35 1.41 1.45 3 2 5 2.71 1.1.39 1.46-.22 1.6-.56.92-2.2 1.68-4.43 2.43-6.69a1.14 1.14 0 0 0 -.5-1.59z",
    fill: "#58595b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m63.27 10.33c-2-.86-3.92-2.25-6.42-1.38a2.78 2.78 0 0 1 -2.53-.89c-1.53-2.73-4.32-3.44-6.84-3.92-10.33-1.94-15.11 2.75-16.77 4.38a.61.61 0 0 0 0 .12c.68-.1 5.63-2.19 9.22.06 1.62 1 2.75 2.35 2.45 4.25a3.32 3.32 0 0 1 0 .95l4.73 1.54c.07-.14.15-.35.23-.48 1.8-2.92 5.4-1.68 7.37.35 1.41 1.45 3 2 5 2.71 1.1.39 1.46-.22 1.6-.56.92-2.2 1.68-4.43 2.43-6.69a1.07 1.07 0 0 0 -.47-.44z",
    fill: "#939598"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m42.34 13.49-5.22 13.64 4.46 1.76 5.72-13.7z",
    fill: "#939598"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m37.7 28.25 5.64-14.53 3.04 1.09-6.12 14.96z",
    fill: "#a7a9ac"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m42.3 13.44-.44 1.33c.37-1 4.49.31 5 1.56l.53-1.25c.36-1.02-4.69-2.66-5.09-1.64z",
    fill: "#58595b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m41.73 28.61-11 31a2 2 0 0 1 -2.59 1.13l-2.83-1.1a2 2 0 0 1 -1.14-2.59l12.92-30.05c.14-.37.82-.4 1.63-.24 1.44.24 3.28 1.24 3.01 1.85z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m41.73 28.61-11 31a2 2 0 0 1 -1.11 1.11l-2.83-1.1a2 2 0 0 1 -1.14-2.62l12.89-30a.39.39 0 0 1 .18-.2c1.44.2 3.28 1.2 3.01 1.81z",
    fill: "#231f20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m29.8 22.76-.61-.24a2.63 2.63 0 0 0 -3.4 1.5l-7.79 19.98v7l6-5 7.3-19.84a2.63 2.63 0 0 0 -1.5-3.4zm-4.47 2.52 5.5 2.11m-12.77 16.28 5.72 2.5",
    fill: "#63b2ff",
    stroke: "#fff",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXcode1);
export default __webpack_public_path__ + "static/media/xcode1.c472ed8e51ae2c857092b3faefd2a6cf.svg";
export { ForwardRef as ReactComponent };